import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import MintUI from "mint-ui"; // 加这一行
import "mint-ui/lib/style.css"; // 和加这一行
import "./style/weui.css"; // 和加这一行
import "./style/common.less";
import "./style/iconfont/iconfont.css";
import utils from "./components/utils/utils";
import "./components/utils/rem"
import axios from "axios";
import store from "./store";
import { btnPermission } from "./directives/btn-permission";
import { LongTouch } from "./directives/longTouch";
import { netWord } from "./directives/netWork";
import vueTouch from "./directives/v-touch";
import { setSystemInfo } from "./systemFolder/utils";
import titleBar from "./components/titleBar/index.vue";

// import '@/assets/text/text.css'

import { post, get, get_from, up_excel } from "./components/utils/axios";

Vue.prototype.$get = get;
Vue.prototype.$get_from = get_from;
Vue.prototype.$up_excel = up_excel;
Vue.prototype.$post = post;

// import VueAMap from 'vue-amap';
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: '81f6681697e10072964308340e1ec931',
//   plugin: ['AMap.Geolocation','AMap.PlaceSearch','AMap.AutoComplet','AMap.MouseTool'],
//   uiVersion: '1.0', // ui库版本，不配置不加载,
//   v: '1.4.4',
// });
import "vue-photo-preview/dist/skin.css";
import { Lazyload } from "mint-ui";
import preview from "vue-photo-preview"; //图片全屏展示 注入全局
let options = {
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: true, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: false, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  arrowEl: true, //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
};
Vue.use(preview, options);
Vue.use(Lazyload);

//解决跨域
Vue.prototype.HOST = "/api";
//引入
Vue.prototype.utils = utils;
Vue.prototype.$axios = axios;
Vue.use(MintUI); // 还有加这一行

Vue.directive('zswipeleft', {
  // 左滑事件
  bind(el, binding) {
      new vueTouch(el, binding, 'swipeleft');
  }
});
Vue.directive('zswiperight', {
  // 右滑事件
  bind(el, binding) {
      new vueTouch(el, binding, 'swiperight');
  }
});

Vue.component("titleBar", titleBar);

// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/dist/css/swiper.css';
// Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  let formUrl = [
    "/reminder",
    "/reminder?type=add",
    "/remindMeds",
    "/my",
    "/queryNucleicAcid",
    // "/login",
    // "/guidePage",
    "/virtualMedicine",
    // "/vcalendar",
    "/medicalRecord",
    "/editDailyTips",
    "/healthCalendar"
    // "/setup",
  ];
  let stopRouter = sessionStorage.getItem("stopRouter");
  // if ( !localStorage.getItem("token") && from.fullPath.indexOf("/remindMeds") > -1 ) {
  //   //如果进入首页没有token直接返回
  //   return false;
  // }
  let goVcalnedarFlag = sessionStorage.getItem("goVcalnedarFlag"); //右滑不可以返回

  if (goVcalnedarFlag == "1") {
    return false;
    //不做操作
  } else if (from.fullPath.indexOf("/remindMeds") > -1 && to.fullPath == "/guidePage") {
    window.exitsApp.call('{"webAction":"exitsApp"}'); //关闭页面
  } else if (
    sessionStorage.getItem("noLogin") == "Y" &&
    ( to.fullPath == "/my" ||
      to.fullPath == "/virtualMedicine" ||
      to.fullPath == "/queryNucleicAcid" ||
      to.fullPath.indexOf("/remindMeds") > -1)
  ) {
    sessionStorage.removeItem("stopRouter");
  } else if (
    to.fullPath.indexOf("/login") > -1 && //校验如果是在login 跳转
    (from.fullPath.indexOf("/registeringAccount") > -1 ||
      from.fullPath.indexOf("/forgotPassword") > -1)
  ) {
    next();
  } else if (
    from.fullPath.indexOf("/login") > -1 &&
    !localStorage.getItem("phone") &&
    sessionStorage.getItem("noLogin") != "Y"
  ) {
    console.log(1111);
    // 游客模式
    next();
  } else if ( stopRouter == "Y" ||  from.fullPath == "/" || !(formUrl.indexOf(from.fullPath) > -1)) {
    console.log(2222);
    next();
  } else if (
    to.fullPath.indexOf("/addPushMessage") > -1 ||
    to.fullPath.indexOf("/popupLogin") > -1
  ) {
    console.log(3333);
    next();
  } else {
    console.log(4444);
    if (window.exitsApp && window.exitsApp.call) {
      //关闭页面
      const result = window.exitsApp.call('{"webAction":"exitsApp"}'); //关闭页面
    }
  }
  sessionStorage.setItem("goVcalnedarFlag", ""); //右滑不可以返回
  sessionStorage.removeItem("stopRouter");
  // let stopRouter = sessionStorage.getItem("stopRouter")
  // if(stopRouter == 'Y' || from.fullPath == "/" || (from.fullPath != "reminder" && from.fullPath != "my")){
  //   next()
  // }else{
  //   next(false)
  // }
});
// 初始化系统信息
setSystemInfo();
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
}).$mount();// 手动挂载组件实例




// WEBPACK FOOTER //
// ./src/main.js